import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { SelectFormField } from "@duosoftbg/nacid-components";
import { useEffect } from "react";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { arUniEntryRequestStatusesThunk } from "../../../../../../../store/redux/slice/AppData/arUniEntryRequestStatuses";

const ARUniEntryRequestStatusSelectField = ({ fieldName, labelCode }) => {
  const dispatch = useAppDispatch();
  const arUniEntryRequestStatuses = useAppSelector((state) => {
    return state.AppData.arUniEntryRequestStatuses;
  });

  useEffect(() => {
    dispatch(arUniEntryRequestStatusesThunk());
  }, [dispatch]);

  return (
    <SelectFormField
      addEmptyOption={true}
      onlyActive={true}
      fieldName={fieldName}
      labelCode={labelCode}
      selectOptions={
        arUniEntryRequestStatuses.data
          ? arUniEntryRequestStatuses.data.map((st) => {
              return { value: st.id, text: st.name, active: st.isActive };
            })
          : []
      }
    />
  );
};
export default ARUniEntryRequestStatusSelectField;
